import React from "react";
import { ReactComponent as YellowCheckMark } from "../../assets/icons/yellowCheckMark.svg";
import { ChevronRightIcon } from "lucide-react";
import "./topBrands.css";
import { ReactComponent as Beats } from "../../assets/icons/brands/Beats.svg";
import { ReactComponent as Nike } from "../../assets/icons/brands/Nike.svg";
import { ReactComponent as LinoPlana } from "../../assets/icons/brands/LoroPiano.svg";
import { ReactComponent as Playstation } from "../../assets/icons/brands/PS.svg";
import { ReactComponent as Xbox } from "../../assets/icons/brands/Xbox.svg";
import { ReactComponent as Rolex } from "../../assets/icons/brands/Rolex.svg";
import { ReactComponent as Gucci } from "../../assets/icons/brands/Gucci.svg";
import { ReactComponent as Apple } from "../../assets/icons/brands/Apple.svg";

const brands = [
  { Icon: Beats, label: "Beats" },
  { Icon: Nike, label: "Nike" },
  { Icon: LinoPlana, label: "Lino Plana" },
  { Icon: Playstation, label: "PlayStation" },
  { Icon: Xbox, label: "Xbox" },
  { Icon: Rolex, label: "Rolex" },
  { Icon: Gucci, label: "Gucci" },
  { Icon: Apple, label: "Apple" },
];

const TopBrands = () => {
  return (
    <div className="topbrands-wrapper">
      {/* Header */}
      <div className="topbrands-header">
        <div className="topbrands-title">
          <YellowCheckMark className="topbrands-check" />
          <span>Top Brands</span>
        </div>

        {/* <button className="topbrands-viewall">
          View All <ChevronRightIcon size={15} strokeWidth={2.5} />
        </button> */}
      </div>

      {/* Brand Cards */}
      <div className="brands-scroll">
        {brands.map(({ Icon, label }, index) => (
          <div className="brand-card" key={index} aria-label={label}>
            <Icon className="brand-icon" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default TopBrands;
